(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.LoneBeacon",
                {
                    url: "/LoneBeacon",
                    component: "loneBeacon",
                    PageTitle: "Lone Beacon",
                    requiredPermissions: "LoneBeacon:View"
                });
        }
    ]);

    app.component("loneBeacon",
        {
            templateUrl: "App/Resources/LoneBeacon/LoneBeacon-template.html",
            controller: loneBeaconController
        });

    loneBeaconController.$inject = ["eligibilityFormApi", "surveys", "eligibilityFormDialog", "amplitudeService", "$window"];

    function loneBeaconController(eligibilityFormApi, surveys, eligibilityFormDialog, amplitudeService, $window) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                loneBeaconStandardId: null,
                loneBeaconPremiumId: null,
                submittedSurveyId: null
            });

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        surveys.then(function (s) {
            $ctrl.lbStandardSurveyId = s.loneBeaconStandardId;
            $ctrl.lbPremiumSurveyId = s.loneBeaconPremiumId;
            eligibilityFormApi.isEnrolled(s.loneBeaconStandardId).then(function (response) {
                if (response) {
                    $ctrl.submittedSurveyId = s.loneBeaconStandardId;
                }
            });

            eligibilityFormApi.isEnrolled(s.loneBeaconPremiumId).then(function (response) {
                if (response) {
                    $ctrl.submittedSurveyId = s.loneBeaconPremiumId;
                }
            });

        });

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event, surveyId) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, surveyId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        };

        $ctrl.openUrl = function (url) {
            $window.open(url);
        };

    }

})(window.app, window.angular); // jshint ignore:line